export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20manga%20style%20illustration%20background%2C%20colorful%20comic%20book%20panels%20with%20action%20scenes%2C%20warm%20orange%20and%20coral%20tones%2C%20soft%20artistic%20watercolor%20texture%2C%20dreamy%20atmosphere%2C%20Japanese%20manga%20aesthetic%2C%20cinematic%20lighting%2C%20no%20text%2C%20abstract%20composition%20with%20subtle%20character%20silhouettes%2C%20high%20quality%20digital%20art&width=1600&height=900&seq=hero-bg-manga-01&orientation=landscape"
          alt="漫画背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-primary-500/20 text-primary-300 border border-primary-400/30 mb-4">
              全网热门漫画
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
              香蕉漫画网 - 海量漫画免费阅读平台
            </h1>

            <p className="text-lg md:text-xl text-primary-200 font-heading mb-6">
              每日更新 · 零成本畅享全本漫画
            </p>

            <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-xl mb-8">
              香蕉漫画网汇聚全网热门漫画资源，涵盖热血、恋爱、奇幻、悬疑、搞笑等全品类免费漫画。每日同步更新最新话，无需注册、无需付费，打开即可畅读全本。无论是最新连载还是经典完结，这里都是你零成本看漫画的最佳选择。
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-8 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-fire-line text-accent-400"></i>
                </span>
                <span className="text-sm text-background-200">日均更新 <strong className="text-background-50">200+</strong> 部</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20">
                  <i className="ri-book-2-line text-primary-400"></i>
                </span>
                <span className="text-sm text-background-200">收录漫画 <strong className="text-background-50">50,000+</strong> 部</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500/20">
                  <i className="ri-shield-check-line text-secondary-400"></i>
                </span>
                <span className="text-sm text-background-200">全本 <strong className="text-background-50">免费</strong> 无广告</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#carousel"
                onClick={(e) => handleClick(e, '#carousel')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-colors whitespace-nowrap"
              >
                <i className="ri-flashlight-line"></i>
                立即阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/30 font-semibold rounded-full text-sm transition-colors whitespace-nowrap"
              >
                <i className="ri-trophy-line"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-[260px] md:w-[320px] lg:w-[380px]">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20anime%20manga%20illustration%20featuring%20a%20young%20adventurous%20character%20in%20vibrant%20orange%20and%20warm%20tones%2C%20Japanese%20comic%20art%20style%2C%20dramatic%20pose%20with%20flowing%20cape%2C%20action%20scene%20background%20with%20speed%20lines%2C%20colorful%20energy%20effects%2C%20clean%20character%20design%2C%20professional%20manga%20illustration%20quality%2C%20bright%20and%20eye-catching%20composition&width=800&height=1100&seq=hero-manga-visual-01&orientation=portrait"
                alt="香蕉漫画网主视觉 - 热血漫画角色"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                <p className="text-xs text-background-200/80">每日更新 · 畅享全本</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}